import { render, staticRenderFns } from "./LoginReset.vue?vue&type=template&id=f747fe1c&"
import script from "./LoginReset.vue?vue&type=script&lang=js&"
export * from "./LoginReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports